import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class InstrumentService extends ApiService {

  public listInstruments() {
    return this.get(CONSTANTS.API.INSTRUMENT.GET_INSTRUMENTS);
  }
  public getInstrumentDetails(data: any) {
    return this.getQueryParams(CONSTANTS.API.INSTRUMENT.GET_INSTRUMENT, data);
  }
  public addInstrument(data: any) {
    return this.post(CONSTANTS.API.INSTRUMENT.ADD_INSTRUMENT, data);
  }
  public updateInstrument(data: any) {
    return this.put(CONSTANTS.API.INSTRUMENT.UPDATE_INSTRUMENT, data);
  }
  public activateInstrument(data: any) {
    return this.delete(CONSTANTS.API.INSTRUMENT.DELETE_INSTRUMENT, data);
  }
  public listInstrumentsExpiry(data: any) {
    return this.getQueryParams(CONSTANTS.API.INSTRUMENT.GET_INSTRUMENTS_EXPIRY, data);
  }
  public addInstrumentExpiry(data: any) {
    return this.put(CONSTANTS.API.INSTRUMENT.ADD_INSTRUMENT_EXPIRY, data);
  }
  public deleteInstrumentExpiry(data: any) {
    return this.deleteQueryParams(CONSTANTS.API.INSTRUMENT.DELETE_INSTRUMENT_EXPIRY, data);
  }
}
